// Lightweight device fingerprint generator — sufficient for casual bot
// deterrence at signup. Combines screen + timezone + canvas hash + UA
// into a stable hex digest, persisted in localStorage so the same device
// reports the same fingerprint on repeat signups (catching the
// many-accounts-from-one-device pattern).
//
// NOT cryptographic. Determined attackers can spoof every input. For real
// abuse defense use FingerprintJS Pro — this is a v0 deterrent shipped
// without external SDK or API key.

const STORAGE_KEY = "zcd_device_fp";

function _hash(str) {
  // FNV-1a 32-bit, then hex pad. Deterministic, no crypto dependency.
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = (h * 16777619) >>> 0;
  }
  return ("00000000" + h.toString(16)).slice(-8);
}

function _canvasFingerprint() {
  try {
    const c = document.createElement("canvas");
    c.width = 240; c.height = 60;
    const ctx = c.getContext("2d");
    ctx.textBaseline = "top";
    ctx.font = "14px 'Arial'";
    ctx.fillStyle = "#069";
    ctx.fillText("zcd-fp-canvas-9.0", 2, 2);
    ctx.strokeStyle = "rgba(102, 204, 0, 0.7)";
    ctx.beginPath();
    ctx.arc(60, 30, 20, 0, Math.PI * 2);
    ctx.stroke();
    return c.toDataURL();
  } catch {
    return "no-canvas";
  }
}

export function getDeviceFingerprint() {
  try {
    const cached = localStorage.getItem(STORAGE_KEY);
    if (cached && cached.length === 16) return cached;
  } catch { /* ignore */ }

  const parts = [
    navigator.userAgent || "",
    navigator.language || "",
    `${screen.width}x${screen.height}x${screen.colorDepth}`,
    Intl.DateTimeFormat().resolvedOptions().timeZone || "",
    String(navigator.hardwareConcurrency || ""),
    _canvasFingerprint(),
  ].join("|");
  const fp = _hash(parts) + _hash(parts.split("").reverse().join(""));

  try { localStorage.setItem(STORAGE_KEY, fp); } catch { /* ignore */ }
  return fp;
}
